<template>
    <div class="left-pane">
        <div class="all-options">
            <div v-if="optionsToProvide.ALL" role="tablist" class="settings-tablist">
                <b-card no-body class="accordion b-card mb-1">
                    <b-card-header header-tag="header" class="accordion-header" role="tab">
                        <b-button class="btn-sm accordion-toggle-btn" block v-b-toggle.accordion1>הגדרות ניקוד
                            <div class="when-closed"><i-caret-up></i-caret-up></div>
                            <div class="when-opened"><i-caret-down></i-caret-down></div>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="accordion1" accordion="settings" role="tabpanel">
                        <div class="accordion-body">
                            <ul class="chapter1 list-unstyled accordion-list">
                                <p id="nikud-rules" class="accordion-body-heading">כללי ניקוד</p>
                                <li>
                                    <b-form-checkbox :checked="!(!(options.ketivMaleh))" @change="(val) => { options.ketivMaleh = val }">
                                        ניקוד בכתיב מלא 
                                    </b-form-checkbox>
                                </li>
                                <li>
                                    <b-form-checkbox :checked="!(!(options.useQamatzQatan))" @change="(val) => { options.useQamatzQatan = val }">
                                        ניקוד בקמץ קטן 
                                    </b-form-checkbox>
                                </li>
                                <li>
                                    <b-form-checkbox :checked="!(!(options.keepSourceDagesh))" @change="(val) => { options.keepSourceDagesh = val }">
                                        השמטת דגש כבמקורות <span id="special-popover-3"><i class="fa fa-info-circle mr-1"></i></span>
                                    </b-form-checkbox>
                                    <b-popover target="special-popover-3" container="" placement="top" triggers="hover focus" :content="KeepSourceDageshTipText">
                                    </b-popover>
                                </li>
                                <li>
                                    <b-form-checkbox :checked="!(!(options.mahPatachDagesh))" @change="(val) => { options.mahPatachDagesh = val }">
                                        ניקוד "מה" בפתח+דגש 
                                    </b-form-checkbox>
                                </li>
                                <hr class="my-2 ml-2"/>
                                <p id="skip-nikud" class="accordion-body-heading">דלג על הניקוד באפשרויות הבאות</p>
                                <li>
                                    <b-form-checkbox :checked="!(!(options.skipLetters))" @change="(val) => options.skipLetters = val"> אות בודדת
                                    </b-form-checkbox>
                                </li>
                                <li>
                                    <b-form-checkbox :checked="!(!(options.skipAbbrevs))" @change="(val) => options.skipAbbrevs = val">
                                        ראשי תיבות
                                    </b-form-checkbox>
                                </li>
                                <li>
                                    <b-form-checkbox
                                            @change="skipAllSurroundersClicked"
                                            :checked="skipAllSurrounders"
                                            :indeterminate="skipSomeSurrounders">
                                        סוגריים
                                        <span @click.prevent="showAllSkipSurrounders = !showAllSkipSurrounders">
                                            <i-caret-down v-show="!showAllSkipSurrounders" />
                                            <i-caret-up v-show="showAllSkipSurrounders" />
                                        </span>
                                    </b-form-checkbox>
                                    <ul v-show="showAllSkipSurrounders" class="section1 accordion-inner-ul">
                                        <li>
                                            <b-form-checkbox :checked="!(!(options.skipParens))" @change="(val) => options.skipParens = val">
                                                עגולים ()
                                            </b-form-checkbox>
                                        </li>
                                        <li>
                                            <b-form-checkbox :checked="!(!(options.skipBrackets))" @change="(val) => options.skipBrackets = val">
                                                מרובעים []
                                            </b-form-checkbox>
                                        </li>
                                        <li>
                                            <b-form-checkbox :checked="!(!(options.skipBraces))" @change="(val) => options.skipBraces = val">
                                                מסולסלים {}
                                            </b-form-checkbox>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <b-form-checkbox :checked="!(!(options.skipVoc))" @change="(val) => options.skipVoc = val">
                                        מילה מנוקדת
                                    </b-form-checkbox>
                                </li>
                                <li>
                                    <b-form-checkbox :checked="!(!(options.skipPartVoc))" @change="(val) => options.skipPartVoc = val">
                                        מילה מנוקדת חלקית
                                    </b-form-checkbox>
                                </li>
                                <hr class="my-2 ml-2"/>
                                <p id="more-options" class="accordion-body-heading">הגדרות נוספות</p>
                                <li>
                                    <b-form-checkbox :checked="!(!(options.splitParens))" @change="(val) => options.splitParens = val">
                                        פצל מילה עם סוגריים <span id="special-popover"><i class="fa fa-info-circle mr-1"></i></span>
                                    </b-form-checkbox>
                                    <b-popover target="special-popover" container="" placement="top" triggers="hover focus" :content="SplitWordParenthesesTipText">
                                    </b-popover>

                                </li>
                                <li>
                                    <b-form-checkbox :checked="!(!(options.dageshOnlyIfHeard))" @change="(val) => options.dageshOnlyIfHeard = val">
                                        השמט דגשים שאינם נשמעים<span id="special-popover-2"><i class="fa fa-info-circle mr-1"></i></span>
                                    </b-form-checkbox>
                                    <b-popover target="special-popover-2" container="" placement="top"  triggers="hover focus" :content="OmittingEmphasesTipText">
                                    </b-popover>
                                </li>
                            </ul>
                        </div>
                    </b-collapse>
                </b-card>
                <b-card no-body class="accordion b-card mb-1">
                    <b-card-header header-tag="header" class="accordion-header" role="tab">
                        <b-button class="btn-sm accordion-toggle-btn" block v-b-toggle.accordion2>סגנון טקסט
                            <div class="when-closed"><i-caret-up></i-caret-up></div>
                            <div class="when-opened"><i-caret-down></i-caret-down></div>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="accordion2" accordion="settings" role="tabpanel">
                        <b-card-body class="accordion-body">
                            <document-settings-genre :options="options" />
                        </b-card-body>
                    </b-collapse>
                </b-card>
                <b-card no-body class="accordion b-card mb-1">
                    <b-card-header header-tag="header" class="accordion-header" role="tab">
                        <b-button class="btn-sm accordion-toggle-btn" block v-b-toggle.accordion3>
                            <div>מסלול ניקוד</div>
                            <div class="when-closed"><i-caret-up></i-caret-up></div>
                            <div class="when-opened"><i-caret-down></i-caret-down></div>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="accordion3" accordion="settings" role="tabpanel">
                        <b-card-body class="accordion-body">
                            <ul class="chapter2 list-unstyled accordion-list">
                                <li @click="options.nikudType='auto'">
                                    <b-form-radio id="use-auto-nikud" value="auto" v-model="options.nikudType">
                                        החל ניקוד על הטקסט
                                    </b-form-radio>
                                    <div class="frame nikud-setting-des">הנקדן יחיל על הטקסט ניקוד אוטומטי. במעבר על
                                        המילה, הנקדן יציג אפשרויות ניקוד ותתאפשר הוספת ניקוד באופן ידני.
                                    </div>
                                </li>
                                <li @click="options.nikudType='manual'">
                                    <b-form-radio id="use-manual-nikud" value="manual" v-model="options.nikudType">
                                        השאר את הטקסט ללא ניקוד
                                    </b-form-radio>
                                    <div class="frame nikud-setting-des">לא יוחל ניקוד על הטקסט. במעבר על המילה, הנקדן
                                        יציג אפשרויות ניקוד ותתאפשר הוספת ניקוד באופן ידני.
                                    </div>
                                </li>
                            </ul>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
            <document-settings-genre v-if="optionsToProvide.ONLY_GENRE" :options="options" />
        </div>
        <api-runner :options="options" /> <!-- if this component's rendered at all, then the "runner" goes here -->
    </div>
</template>

<script>
    // @ is an alias to /src
    import serviceMixins from '@/mixins/serviceMixins'
    import DocumentSettingsGenre from './DocumentSettingsGenre'
    import ApiRunner from './ApiRunner'
    import {BlankState} from '@/store/stateParts'
    import {AppConfig} from '@/appConfig'
    import {loadingPromise} from '../js/localData'
    import {getDevFrontendSettings} from 'shared/js/devMode'

    const autoNikudDescription = 'הנקדן יחיל על הטקסט ניקוד אוטומטי. במעבר על המילה, הנקדן יציג אפשרויות ניקוד ותתאפשר הוספת ניקוד באופן ידני. '
    const manualNikudDescription = 'לא יוחל ניקוד על הטקסט. במעבר על המילה, הנקדן יציג אפשרויות ניקוד ותתאפשר הוספת ניקוד באופן ידני.'
    const SplitWordParentheses = 'מילה מפוצלת, מתייחסת אל המילה שבסוגריים כאל יחידה עצמאית.\n לדוגמא שומר[ות] - שומר, ות.'
    const OmittingEmphases = 'הנקדן יציג דגשים רק עבור האותיות בהם הדגש נשמע (ב, כ, פ)'
    const KeepSourceDagesh = 'השמטת הדגש במ\' שוואית אחרי יידוע'

    export default {
        name: 'DocumentSettings',
        components: {
            DocumentSettingsGenre,
            ApiRunner
        },
        mixins: [serviceMixins], // for gtag()
        data() {
            return {
                showTextTooLongPrompt: false,
                showAllSkipSurrounders: false,
                autoNikudToolTipText: autoNikudDescription,
                manualNikudToolTipText: manualNikudDescription,
                SplitWordParenthesesTipText: SplitWordParentheses,
                OmittingEmphasesTipText: OmittingEmphases,
                KeepSourceDageshTipText: KeepSourceDagesh,
                options: JSON.parse(JSON.stringify(BlankState.preSubmissionOptions))
            }
        },
        computed: {
            optionsToProvide () {
                return AppConfig.PRE_SUBMISSION_OPTIONS_TO_SHOW
            },
            skipAllSurrounders() {
                return this.options.skipBraces && this.options.skipParens && this.options.skipBrackets
            },
            skipSomeSurrounders() {
                return !(this.skipAllSurrounders) && (this.options.skipBraces || this.options.skipParens || this.options.skipBrackets)
            }
        },
        methods: {
            specialOptionsUpdates() {
                // first, deal with any "obsolete" special options that may have been loaded from a SAVED state
                const dropboxId = this.options.dropboxIdForSpecialOptions
                if (dropboxId
                    && (!(this.$store.state.dropbox && this.$store.state.dropbox.status)
                        || this.$store.state.dropbox.status.id !== dropboxId)) {
                    Object.keys(this.options).forEach(k => {
                        if (typeof this.options[k] === 'number') {
                            this.options[k] = BlankState.preSubmissionOptions[k]
                        }
                    })
                    this.options.dropboxIdForSpecialOptions = null
                    // console.log('file ' + dropboxId + ' "unloaded" - reverted any special options to defaults')
                }
                // next, see if any special options need to be loaded from dropbox.projectSettings NOW
                const abbrevProjectSettings = this.$store.state.dropbox?.projectSettings?.abbreviation
                if (abbrevProjectSettings
                        && abbrevProjectSettings.preSubmissionOptions
                        && typeof abbrevProjectSettings.preSubmissionOptions === 'object'
                        && this.$store.state.dropbox.status) { // the last SHOULD not be needed, but just in case...
                    const loadedFileOptions = abbrevProjectSettings.preSubmissionOptions
                    Object.keys(loadedFileOptions).forEach(k => {
                        if (Object.prototype.hasOwnProperty.call(BlankState.preSubmissionOptions, k)) {
                            this.options[k] = loadedFileOptions[k] ? 1 : 0
                        }
                    })
                    this.options.dropboxIdForSpecialOptions = this.$store.state.dropbox.status.id
                    // console.log('file ' + this.options.dropboxIdForSpecialOptions + ' loaded with special options')
                }
                // finally, see if there are any options to be loaded from "dev mode" (note: this won't affect genre)
                const devFrontendSettings = getDevFrontendSettings('abbreviation')
                if (devFrontendSettings?.preSubmissionOptions && typeof devFrontendSettings.preSubmissionOptions === 'object') {
                    Object.keys(devFrontendSettings.preSubmissionOptions).forEach(k => {
                        if (Object.prototype.hasOwnProperty.call(BlankState.preSubmissionOptions, k)) {
                            this.options[k] = devFrontendSettings.preSubmissionOptions[k]
                        }
                    })
                }
            },
            skipAllSurroundersClicked() {
                const setTo = !this.skipAllSurrounders
                this.options.skipBraces = setTo
                this.options.skipParens = setTo
                this.options.skipBrackets = setTo
            }
        },
        async created() {
          await loadingPromise
          this.options = JSON.parse(JSON.stringify(this.$store.state.preSubmissionOptions))
          this.specialOptionsUpdates()
        }
    }
</script>

<style scoped>
    /* DocumentSettings-specific CSS goes here */
    /*only of this page*/
    .left-pane {
        height: 100%;
        display: flex;
        flex-direction: column;
        border-radius: 4px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
        margin-left: 12px;
        text-align: left;
        direction: ltr;
    }

    .he .left-pane{
       margin-right: 12px;
       margin-left: 0;
       text-align: right;
       direction: rtl;
    }

    .left-pane .all-options {
        flex: auto;
        height: calc(100% - 69px); /* the החל button & margin = 69px */
    }
    .settings-tablist {
        height: calc(100% - 60px); /* the two other cards * 28px each = 56px + 4px margin between them */
    }

    .accordion-list {
        margin: 0 10px 0 0;
        padding: 0;
    }

    .accordion-body-heading {
        margin: 0 0 5px;
    }

    .accordion-body .accordion-body-heading {
        font-size: 13px;
    }

    .accordion-body {
        padding: 5px 0 10px;
    }
    .collapse {
        overflow-y: auto;
        height: 100%;
    }

    .accordion {
        background: transparent;
        border: none;
        max-height: 100%;
    }

    .accordion-inner-ul {
        margin: 5px 20px 5px 10px;
        padding: 0;
        list-style: none;
    }

    .nikud-setting-des {
        font-size: 13px;
        padding: 10px;
        margin-bottom: 15px;
        margin-top: 8px;
    }

    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }
</style>
